// API client for Main Categories (formerly Shop Tags)
// Backend controller: /api/main-categories
import {apiUrl} from '../config/api'

export async function listShopTags() {
  const res = await fetch(apiUrl('/api/main-categories'), {
    headers: { 'Accept': 'application/json' },
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function createShopTag(payload) {
  const res = await fetch(apiUrl('/api/main-categories'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function updateShopTag(id, payload) {
  const res = await fetch(apiUrl(`/api/main-categories/${id}`), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteShopTag(id) {
  const res = await fetch(apiUrl(`/api/main-categories/${id}`), {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return true;
}
